import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const getUploadUrl = (fileName, contentType, fileSize) =>
  axios
    .post(`${API_URL}/api/documents/upload-url`, { fileName, contentType, fileSize }, authHeaders())
    .then((r) => r.data);

const createDocument = (data) =>
  axios
    .post(`${API_URL}/api/documents`, data, authHeaders())
    .then((r) => r.data);

const getDocuments = (params = {}) =>
  axios
    .get(`${API_URL}/api/documents`, { ...authHeaders(), params })
    .then((r) => r.data);

const updateDocument = (id, data) =>
  axios
    .patch(`${API_URL}/api/documents/${id}`, data, authHeaders())
    .then((r) => r.data);

const archiveDocument = (id, archived) =>
  axios
    .patch(`${API_URL}/api/documents/${id}/archive`, { archived }, authHeaders())
    .then((r) => r.data);

const deleteDocument = (id) =>
  axios
    .delete(`${API_URL}/api/documents/${id}`, authHeaders())
    .then((r) => r.data);

const searchLotCodes = (q) =>
  axios
    .get(`${API_URL}/api/documents/lot-codes`, { ...authHeaders(), params: { q } })
    .then((r) => r.data.lotCodes || []);

const getDocumentsForBol = (bolId) =>
  axios
    .get(`${API_URL}/api/documents/for-bol/${bolId}`, authHeaders())
    .then((r) => r.data.documents || []);

const getDocumentsForIngredient = (ingredientId) =>
  axios
    .get(`${API_URL}/api/documents/for-ingredient/${ingredientId}`, authHeaders())
    .then((r) => r.data.documents || []);

const getDocumentsForCustomer = (customerId) =>
  axios
    .get(`${API_URL}/api/documents/for-customer/${customerId}`, authHeaders())
    .then((r) => r.data.documents || []);

const documentService = {
  getUploadUrl,
  createDocument,
  getDocuments,
  updateDocument,
  archiveDocument,
  deleteDocument,
  getDocumentsForBol,
  getDocumentsForIngredient,
  getDocumentsForCustomer,
  searchLotCodes,
};

export default documentService;
